import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "copy",
  "use": "copy-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"copy\"><path fill-rule=\"evenodd\" d=\"M4.5 2c-1.1 0-2 .9-2 2v13h2V4h12V2h-12Zm4 4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-11Zm0 14V8h11v12h-11Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol